import * as React from "react";

const SvgComponent = ({ color = "#666666", ...props }) => (
  <svg
    width={11}
    height={6}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 11 5"
    {...props}
  >
    <path
      d="M9.307.135 5.168 3.893 1.03.134a.541.541 0 0 0-.713 0 .43.43 0 0 0 0 .649L4.81 4.866a.54.54 0 0 0 .714 0L10.02.783a.43.43 0 0 0 0-.65.54.54 0 0 0-.713.002Z"
      fill={color}
    />
  </svg>
);

export default SvgComponent;